<template>
    <div class="is-clipped">
        <agile
            ref="main"
            :fade="true"
            :as-nav-for="asNavFor1"
            :options="options1"
        >
            <div
                v-for="(slide, index) in images"
                :key="index"
                :class="`slide--${index}`"
                class="slide"
            >
                <img :src="slide.url" loading="lazy" alt />
            </div>
        </agile>

        <agile
            ref="thumbnails"
            :as-nav-for="asNavFor2"
            :slides-to-show="4"
            :options="options2"
            class="thumbnails"
        >
            <div
                v-for="(slide, index) in images"
                :key="index"
                :class="`slide--${index}`"
                @click="$refs.thumbnails.goTo(index)"
                class="slide--thumbnail"
            >
                <img :src="slide.url" loading="lazy" alt />
            </div>
            <template slot="prevButton">
                <i class="fas fa-chevron-left"></i>
            </template>

            <template slot="nextButton">
                <i class="fas fa-chevron-right"></i>
            </template>
        </agile>
    </div>
</template>

<script>
import { VueAgile } from 'vue-agile';
export default {
    components: {
        agile: VueAgile,
    },
    props: {
        images: {
            type: Array,
            default() {
                return [];
            },
        },
        showing: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            asNavFor1: [],
            asNavFor2: [],
            options1: {
                dots: false,
                fade: true,
                navButtons: false,
                speed: 2500,
            },

            options2: {
                autoplay: true,
                centerMode: true,
                dots: false,
                navButtons: false,
                slidesToShow: 4,
                responsive: [
                    {
                        breakpoint: 600,
                        settings: {
                            slidesToShow: 4,
                        },
                    },

                    {
                        breakpoint: 1000,
                        settings: {
                            navButtons: true,
                        },
                    },
                ],
            },
        };
    },
    mounted() {
        this.$nextTick(function () {
            this.$refs.main.reload();
        });
        this.asNavFor1.push(this.$refs.thumbnails);
        this.asNavFor2.push(this.$refs.main);
    },
};
</script>

<style lang="sass" scoped>
@import "src/assets/sass/slider"
.thumbnails
    margin: 0 -5px
    width: calc(100% + 10px)

// Basic VueAgile styles
::v-deep.agile
    &__nav-button
        background: transparent
        border: none
        color: #ccc
        cursor: pointer
        font-size: 24px
        transition-duration: .3s

        .thumbnails &
            position: absolute
            top: 50%
            transform: translateY(-50%)

            &--prev
                left: 0px

            &--next
                right: 0px

        &:hover
            color: #888

    &__dot
        margin: 0 10px

        button
            background-color: #eee
            border: none
            border-radius: 50%
            cursor: pointer
            display: block
            height: 10px
            font-size: 0
            line-height: 0
            margin: 0
            padding: 0
            transition-duration: .3s
            width: 10px

        &--current,
        &:hover
            button
                background-color: #888

// Slides styles	
.slide
    align-items: center
    box-sizing: border-box
    color: #fff
    display: flex
    height: 450px
    justify-content: center

    &--thumbnail
        cursor: pointer
        height: 100px
        transition: opacity .3s

        &:hover
            opacity: .75

    img
        height: 100% !important
        object-fit: cover !important
        object-position: center !important
        width: 100% !important
</style>
